import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setRoute('mollie_transactions_list')
    .setAdditionalRoutes([
        'mollie_transaction_matching',
    ]);
